import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CurrencyRateDetails } from 'further-types/lp/transaction';

type CurrencyRateOverridesMap = Map<CurrencyCode, CurrencyRateDetails>;

type ContextValue = {
  currencyRateOverrides: CurrencyRateOverridesMap;
  setCurrencyRateOverrides: React.Dispatch<
    React.SetStateAction<CurrencyRateOverridesMap>
  >;
};

const PostUnrealisedFxGainsContext = createContext<ContextValue | undefined>(
  undefined,
);

export const PostUnrealisedFxGainsProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [currencyRateOverrides, setCurrencyRateOverrides] =
    useState<CurrencyRateOverridesMap>(new Map());

  return (
    <PostUnrealisedFxGainsContext.Provider
      value={{ currencyRateOverrides, setCurrencyRateOverrides }}
    >
      {children}
    </PostUnrealisedFxGainsContext.Provider>
  );
};

export const usePostUnrealisedFxGainsContext = () => {
  const ctx = useContext(PostUnrealisedFxGainsContext);
  if (!ctx)
    throw new Error(
      'usePostUnrealisedFxGainsContext must be used within PostUnrealisedFxGainsProvider',
    );
  return ctx;
};
